export default "__VITE_ASSET__CeQWvT0i__"